<template>
    <svg v-html="icon" v-bind="svgAttributes" xmlns="http://www.w3.org/2000/svg"></svg>
  </template>
  
  <script>
  import icons from '@/assets/svg/svg-icons.js'; // Adjust the path as necessary
  
  export default {
    props: {
      name: {
        type: String,
        required: true
      },
      class: {
        type: String,
        default: ''
      },
      width: {
        type: String,
        default: '24'
      },
      height: {
        type: String,
        default: '24'
      },
      viewBox: {
        type: String,
        default: '0 0 24 24' // Default viewBox, can be overridden
      },
      fill: {
        type: String,
        default: 'none'
      }
    },
    setup(props) {
      const icon = icons[props.name] || '';
  
      // Create svgAttributes object with dynamic values
      const svgAttributes = {
        class: props.class,
        width: props.width,
        height: props.height,
        viewBox: props.viewBox,
        fill: props.fill
      };
  
      // Use a reactive object to handle changes in attributes
      return {
        icon,
        svgAttributes
      };
    }
  }
  </script>
  